<script setup lang="ts">
import type { Property } from '~/core/entities/property';

import PropertyPhotoCarouselDesktopDeprecated from '~/components/PropertyPhotoCarouselDesktopDeprecated/CarouselDesktop.vue';
import PropertyPhotoCarouselMobileDeprecated from '~/components/PropertyPhotoCarouselMobileDeprecated/CarouselMobile.vue';

interface PropertyHeroCarouselsDeprecatedProps {
	property: Property | null;
	isLoading: boolean;
}

defineProps<PropertyHeroCarouselsDeprecatedProps>();

defineEmits<{
	'photo-clicked': [
		payload: {
			photoIndex: number;
			photoUrl: string;
			clickType: 'photo' | 'cta';
		}
	];
}>();
</script>

<template>
	<PropertyPhotoCarouselDesktopDeprecated
		:property="property"
		:images="property?.images || []"
		:is-loading="isLoading"
		section-name="hero section"
		@photo-clicked="$emit('photo-clicked', $event)"
	/>

	<PropertyPhotoCarouselMobileDeprecated
		:property="property"
		:images="property?.images || []"
		:is-loading="isLoading"
		section-name="hero section"
		@photo-clicked="$emit('photo-clicked', $event)"
	/>
</template>
